// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"sx_a bhl_b bhl_bj","SubscribedPhotoblogs__link":"sx_b bhl_a bhl_r"};